import React from "react";
import styled from "styled-components";
import { useObtenerAsistenciaDiaria } from "../../../services/asistenciaServicios";
import { Spinner } from "react-bootstrap";

function TablaAsistenciaDiaria() {
  const {
    data: listaAsistencia,
    isLoading: listaAsistenciaIsLoading
  } = useObtenerAsistenciaDiaria();

  const asistenciasIngresadas = listaAsistencia?.asistencias || [];

  return (
    <StyledTable className="table table-hover">
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Nombre</th>
          <th>Propietario</th>
          <th>Ingresó</th>
        </tr>
      </thead>
      <tbody>
        {asistenciasIngresadas.map((asistencia, i) => {
          return (
            <tr key={i}>
              <td>{i + 1}.</td>
              <td>{asistencia.nombreMascota}</td>
              <td>{asistencia.nombrePropietario}</td>
              <td>{asistencia.asistio ? "Si" : "No"}</td>
            </tr>
          );
        })}

        {listaAsistenciaIsLoading && (
          <tr>
            <td>
              <Spinner size="sm" animation="grow" />
            </td>
            <td>
              <Spinner size="sm" animation="grow" />
            </td>
            <td>
              <Spinner size="sm" animation="grow" />
            </td>
            <td>
              <Spinner size="sm" animation="grow" />
            </td>
          </tr>
        )}
      </tbody>
    </StyledTable>
  );
}

const StyledTable = styled("table")`
  & > thead > tr > th {
    border-bottom: 1px;
    font-size: 16px;
    font-weight: 500;
  }
`;

export default TablaAsistenciaDiaria;
